import { Flex } from "antd";
import React from "react";
import "./plates.css";
export default function Plates({ plates, plateClicked }) {
  return (
    plates &&
    plates.map((item) => (
      <Flex
        gap={"1rem"}
        align={"center"}
        className="box"
        key={item._id.$oid}
        onClick={() => {
          plateClicked(item);
        }}
      >
        <Flex vertical>
          <div>{item.name}</div>
          <div>{item.description}</div>
        </Flex>
      </Flex>
    ))
  );
}
